import { lazyPage } from '@app/utils/routeUtils'
import { useParams } from 'react-router-dom'

interface ParameterGuardProps {
  children: React.ReactNode
  parameterName: string
  validValues: string[]
}

// Generic guard to validate any path parameter against valid values
export const ParameterGuard: React.FC<ParameterGuardProps> = ({ children, parameterName, validValues }) => {
  const params = useParams<Record<string, string>>()
  const paramValue = params[parameterName]

  if (!paramValue || !validValues.includes(paramValue)) {
    return lazyPage('PageNotFound', 'PageNotFound')
  }

  return children
}
